const getters = {
	// data
	getListPaketDeposit: (state) => state.listPaketDeposit,
	getListPaketDepositOwner: (state) => state.listPaketDepositOwner,
	getListTransaksiDeposit: (state) => state.listTransaksiDeposit,
	getListTopupDeposit: (state) => state.listTopupDeposit,
	getInfoTopupDeposit: (state) => state.infoTopupDeposit,
	getDetailTopupDeposit: (state) => state.detailTopupDeposit,

	// filter
	getPagination: (state) => state.pagination,

	// search
	getSearchTopup: (state) => state.searchTopup,
	getIsSearchTopup: (state) => state.isSearchTopup,

	getScrollPosition: (state) => state.scrollPosition,
}

export default getters